import { Provider } from "@angular/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from "@angular/material/form-field";

export const MatFormFieldDefaultOptionsProvider: Provider = {
  provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
  useValue: {
    subscriptSizing: 'dynamic',
    appearance: 'outline'
  } as MatFormFieldDefaultOptions
};